import React, { useEffect, useMemo, useState } from 'react'
import { getLength } from 'commons/function'

import styles from './EcosystemNew.module.scss'
import { arrProjectNew } from 'commons/constant'
import { Link } from 'react-router-dom'
import images from 'assets/images'
import useResizeWidth from 'controller/useResizeWidth'
import { ChevronDownIcon, ChevronUpIcon } from 'lucide-react'
import Button from 'components/Button'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Pagination, Autoplay } from 'swiper/modules'

const arrProject = [
  {
    icon: images.ecoWallet1,
    name: 'Coin98 Super Wallet',
    value: 'wallet',
    link: 'https://coin98.com/',
  },
  {
    icon: images.ecoWallet2,
    name: 'Viction Wallet',
    value: 'wallet',
    link: 'https://viction.xyz/wallet',
  },
  {
    icon: images.ecoWallet3,
    name: 'Ramper',
    value: 'wallet',
    link: 'https://www.ramper.xyz/',
  },
  {
    icon: images.ecoWallet4,
    name: 'MetaMask',
    value: 'wallet',
    link: 'https://metamask.io/',
  },
  {
    icon: images.ecoWallet5,
    name: 'Cobo',
    value: 'wallet',
    link: 'https://www.cobo.com/',
  },
  {
    icon: images.ecoWallet6,
    name: 'Trezor',
    value: 'wallet',
    link: 'https://trezor.io/',
  },
  {
    icon: images.ecoWallet7,
    name: 'Privy',
    value: 'wallet',
    link: 'https://www.privy.io/',
  },
  {
    icon: images.ecoWallet8,
    name: 'iMe',
    value: 'wallet',
    link: 'https://imem.app/',
  },
  {
    icon: images.ecoWallet9,
    name: 'Reown',
    value: 'wallet',
    link: 'https://reown.com/blog/how-to-get-started-with-reown-appkit-on-viction',
  },
  {
    icon: images.ecoWallet10,
    name: 'imToken',
    value: 'wallet',
    link: 'https://token.im/',
  },
  {
    icon: images.ecoWallet11,
    name: 'Fox Wallet',
    value: 'wallet',
    link: 'https://foxwallet.com/',
  },
  {
    icon: images.ecoWallet12,
    name: 'SubWallet',
    value: 'wallet',
    link: 'https://www.subwallet.app/',
  },
  {
    icon: images.ecoWallet13,
    name: 'Frontier',
    value: 'wallet',
    link: 'https://twitter.com/Frontier_DAO',
  },
  {
    icon: images.ecoWallet14,
    name: 'Nabox',
    value: 'wallet',
    link: 'https://nabox.io/',
  },
  {
    icon: images.ecoWallet15,
    name: 'Hybrix',
    value: 'wallet',
    link: 'https://hybrix.io/',
  },
  {
    icon: images.ecoWallet16,
    name: 'Blazpay',
    value: 'wallet',
    link: 'https://blazpay.com/',
  },
  {
    icon: images.ecoWallet17,
    name: 'Fearless',
    value: 'wallet',
    link: 'http://fearlesswallet.io',
  },
  {
    icon: images.ecoWallet18,
    name: 'Nuvo',
    value: 'wallet',
    link: 'https://www.nuvosphere.io/',
  },
  {
    icon: images.ecoWallet19,
    name: 'Krystal',
    value: 'wallet',
    link: 'https://defi.krystal.app/',
  },
  {
    icon: images.ecoWallet20,
    name: 'Piena',
    value: 'wallet',
    link: 'https://www.plena.finance/',
  },
  {
    icon: images.ecoWallet21,
    name: 'Trust',
    value: 'wallet',
    link: 'https://trustwallet.com/?utm_source=cryptwerk',
  },
  {
    icon: images.ecoWallet22,
    name: 'Holdstation',
    value: 'wallet',
    link: 'https://holdstation.com/',
  },
  {
    icon: images.ecoWallet23,
    name: 'Math Wallet',
    value: 'wallet',
    link: 'https://mathwallet.org/en-us/',
  },
  {
    icon: images.ecoWallet24,
    name: 'Desig',
    value: 'wallet',
    link: 'https://desig.io/',
  },
  {
    icon: images.ecoWallet25,
    name: 'SendToken',
    value: 'wallet',
    link: 'https://www.sendtokens.xyz/',
  },
  {
    icon: images.ecoWallet26,
    name: 'MyCrypt',
    value: 'wallet',
    link: 'https://mycrypto.com/',
  },
  {
    icon: images.ecoWallet27,
    name: 'MEW',
    value: 'wallet',
    link: 'https://www.myetherwallet.com/',
  },
  {
    icon: images.ecoWallet28,
    name: 'BlockWallet',
    value: 'wallet',
    link: 'https://blockwallet.io/',
  },
  {
    icon: images.ecoWallet29,
    name: 'NOW Wallet',
    value: 'wallet',
    link: 'https://walletnow.app/',
  },
  {
    icon: images.ecoWallet30,
    name: 'Wigwam',
    value: 'wallet',
    link: 'https://wigwam.app/',
  },
  {
    icon: images.ecoWallet31,
    name: 'INTOverse',
    value: 'wallet',
    link: 'https://intoverse.co/',
  },
  {
    icon: images.ecoWallet32,
    name: 'Token Pocket',
    value: 'wallet',
    link: 'https://www.tokenpocket.pro/',
  },
  {
    icon: images.ecoWallet33,
    name: 'Zen Card',
    value: 'wallet',
    link: 'https://www.zencard.co/',
  },
  {
    icon: images.ecoWallet34,
    name: 'Enkrypt',
    value: 'wallet',
    link: 'https://www.enkrypt.com/',
  },
  {
    icon: images.ecoDefi1,
    name: 'RabbitSwap',
    value: 'defi',
    link: 'https://rabbitswap.xyz/',
  },
  {
    icon: images.ecoDefi2,
    name: 'Mori',
    value: 'defi',
    link: 'https://app.moriprotocol.io/',
  },
  {
    icon: images.ecoDefi3,
    name: 'Baryon',
    value: 'defi',
    link: 'https://www.baryon.network/',
  },
  {
    icon: images.ecoDefi4,
    name: 'BrownFi',
    value: 'defi',
    link: 'https://browndex.io/',
  },
  {
    icon: images.ecoDefi5,
    name: 'LetsExchange',
    value: 'defi',
    link: 'https://letsexchange.io/',
  },
  {
    icon: images.ecoDefi6,
    name: 'deFusion',
    value: 'defi',
    link: 'https://www.defusion.xyz/',
  },
  {
    icon: images.ecoDefi7,
    name: 'Starship',
    value: 'defi',
    link: 'https://starship.network/',
  },
  {
    icon: images.ecoDefi8,
    name: 'SimpleSwap',
    value: 'defi',
    link: 'https://simpleswap.io/',
  },
  {
    icon: images.ecoDefi9,
    name: 'Vix',
    value: 'defi',
    link: 'https://vix.trade/',
  },
  {
    icon: images.ecoDefi10,
    name: 'StakeKit',
    value: 'defi',
    link: 'https://www.stakek.it/',
  },
  {
    icon: images.ecoBridge1,
    name: 'LayerZero',
    value: 'bridge',
    link: 'https://layerzero.network/',
  },
  {
    icon: images.ecoBridge2,
    name: 'Hyperlane',
    value: 'bridge',
    link: 'https://www.hyperlane.xyz/',
  },
  {
    icon: images.ecoBridge3,
    name: 'AIT Protocol',
    value: 'bridge',
    link: 'https://aitprotocol.ai/',
  },
  {
    icon: images.ecoBridge4,
    name: 'OmniHub',
    value: 'bridge',
    link: 'https://omnihub.xyz/',
  },
  {
    icon: images.ecoBridge5,
    name: 'ZeroWay',
    value: 'bridge',
    link: 'https://zeroway.io/',
  },
  {
    icon: images.ecoBridge6,
    name: 'Arken',
    value: 'bridge',
    link: 'https://arken.ag/',
  },
  {
    icon: images.ecoBridge7,
    name: 'Interport',
    value: 'bridge',
    link: 'https://interport.fi/',
  },
  {
    icon: images.ecoBridge8,
    name: 'SpaceGate',
    value: 'bridge',
    link: 'https://docs.coin98.com/products/coin98-super-wallet/mobile/spacegate',
  },
  {
    icon: images.ecoBridge9,
    name: 'L2 Marathon',
    value: 'bridge',
    link: 'https://l2marathon.com/',
  },
  {
    icon: images.ecoPayment1,
    name: 'WSPN',
    value: 'payment',
    link: 'https://wspn.io/',
  },
  {
    icon: images.ecoPayment2,
    name: 'Verified USD',
    value: 'payment',
    link: 'https://usdv.money/',
  },
  {
    icon: images.ecoPayment3,
    name: 'CUSD',
    value: 'payment',
    link: 'https://stably.io/',
  },
  {
    icon: images.ecoPayment4,
    name: 'Fireblocks',
    value: 'payment',
    link: 'https://www.fireblocks.com/',
  },
  {
    icon: images.ecoPayment5,
    name: 'Stably',
    value: 'payment',
    link: 'https://stably.io/',
  },
  {
    icon: images.ecoPayment6,
    name: 'Ceffu',
    value: 'payment',
    link: 'https://www.ceffu.com/',
  },
  {
    icon: images.ecoPayment7,
    name: 'NOW Payments',
    value: 'payment',
    link: 'https://nowpayments.io/',
  },
  {
    icon: images.ecoPayment8,
    name: 'Alchemy Pay',
    value: 'payment',
    link: 'https://alchemypay.org/',
  },
  {
    icon: images.ecoGamefi1,
    name: 'Eternals',
    value: 'gamefi',
    link: 'https://twitter.com/Eternals_World',
  },
  {
    icon: images.ecoGamefi2,
    name: 'Town Story',
    value: 'gamefi',
    link: 'https://townstory.io/',
  },
  {
    icon: images.ecoGamefi3,
    name: 'Cyborg Heros',
    value: 'gamefi',
    link: 'https://www.cyborg.game/game/cyborg_heroes',
  },
  {
    icon: images.ecoGamefi4,
    name: 'Summoners Arena',
    value: 'gamefi',
    link: 'https://summonersarena.io/',
  },
  {
    icon: images.ecoGamefi5,
    name: 'Gunstar',
    value: 'gamefi',
    link: 'https://gunstar.io/',
  },
  {
    icon: images.ecoGamefi6,
    name: 'World of Dypians',
    value: 'gamefi',
    link: 'https://www.worldofdypians.com/',
  },
  {
    icon: images.ecoGamefi7,
    name: 'Counter Fire',
    value: 'gamefi',
    link: 'https://www.counterfire.games/home',
  },
  {
    icon: images.ecoGamefi8,
    name: 'Cyborg',
    value: 'gamefi',
    link: 'https://www.cyborg.game/',
  },
  {
    icon: images.ecoGamefi9,
    name: 'Space3',
    value: 'gamefi',
    link: 'https://space3.gg/',
  },
  {
    icon: images.ecoGamefi10,
    name: 'EfiHub',
    value: 'gamefi',
    link: 'https://efihub.io/',
  },
  {
    icon: images.ecoGamefi11,
    name: 'DAR',
    value: 'gamefi',
    link: 'https://www.dalarnia.com/',
  },
  {
    icon: images.ecoNft1,
    name: 'Contrarians',
    value: 'nft',
    link: 'https://hub.xyz/the-contrarians',
  },
  {
    icon: images.ecoNft2,
    name: 'Eternals',
    value: 'nft',
    link: 'https://twitter.com/Eternals_World',
  },
  {
    icon: images.ecoNft3,
    name: 'Ivy',
    value: 'nft',
    link: 'https://bento.me/theivynft',
  },
  {
    icon: images.ecoNft4,
    name: 'LiveArt',
    value: 'nft',
    link: 'https://liveart.io/',
  },
  {
    icon: images.ecoNft5,
    name: 'Micro3',
    value: 'nft',
    link: 'https://micro3.io/',
  },
  {
    icon: images.ecoNft6,
    name: 'NFTs2Me',
    value: 'nft',
    link: 'https://nfts2me.com/',
  },
  {
    icon: images.ecoNft7,
    name: 'Omnisea',
    value: 'nft',
    link: 'https://omnisea.org/',
  },
  {
    icon: images.ecoNft8,
    name: 'Atlas 3',
    value: 'nft',
    link: 'https://atlas3.io/',
  },
  {
    icon: images.ecoNft9,
    name: 'CoNFT',
    value: 'nft',
    link: 'https://conft.app/',
  },
  {
    icon: images.ecoNft10,
    name: 'Autharium',
    value: 'nft',
    link: 'https://autharium.jp/',
  },
  {
    icon: images.ecoNft11,
    name: 'Yunero',
    value: 'nft',
    link: 'https://yunero.io/',
  },
  {
    icon: images.ecoNft12,
    name: 'Tezuka',
    value: 'nft',
    link: 'https://tezuka.io/',
  },
  {
    icon: images.ecoNft13,
    name: 'Dagora',
    value: 'nft',
    link: 'https://dagora.xyz/',
  },
  {
    icon: images.ecoNft14,
    name: 'Ostro',
    value: 'nft',
    link: 'https://x.com/OstroStudio',
  },
  {
    icon: images.ecoNft15,
    name: 'MeendArt',
    value: 'nft',
    link: 'https://www.meendart.com/',
  },
  {
    icon: images.ecoExchange1,
    name: 'Binance',
    value: 'exchange',
    link: 'https://www.binance.com/',
  },
  {
    icon: images.ecoExchange2,
    name: 'Bybit',
    value: 'exchange',
    link: 'https://www.bybit.com/vi-VN/',
  },
  {
    icon: images.ecoExchange3,
    name: 'Gate',
    value: 'exchange',
    link: 'https://www.gate.com/vi',
  },
  {
    icon: images.ecoExchange4,
    name: 'MEXC',
    value: 'exchange',
    link: 'https://www.mexc.com/',
  },
  {
    icon: images.ecoExchange5,
    name: 'Aliniex',
    value: 'exchange',
    link: 'https://aliniex.com/en/trade/vic',
  },
  {
    icon: images.ecoExchange6,
    name: 'AscendEX',
    value: 'exchange',
    link: 'https://ascendex.com/en',
  },
  {
    icon: images.ecoExchange7,
    name: 'BTSE',
    value: 'exchange',
    link: 'https://www.btse.com/en/home',
  },
  {
    icon: images.ecoExchange8,
    name: 'Biconomy',
    value: 'exchange',
    link: 'https://biconomy.com/',
  },
  {
    icon: images.ecoExchange9,
    name: 'Bitget',
    value: 'exchange',
    link: 'https://www.bitget.com/',
  },
  {
    icon: images.ecoExchange10,
    name: 'StealthEX',
    value: 'exchange',
    link: 'https://stealthex.io/',
  },
  {
    icon: images.ecoExchange11,
    name: 'Coins.ph',
    value: 'exchange',
    link: 'http://Coins.ph',
  },
  {
    icon: images.ecoExchange12,
    name: 'BitMart',
    value: 'exchange',
    link: 'https://www.bitmart.com/en-US/trade/$VIC_USDT?r=PjkAFy',
  },
  {
    icon: images.ecoExchange13,
    name: 'LBank',
    value: 'exchange',
    link: 'https://www.lbank.com/trade/viction_usdt',
  },
  {
    icon: images.ecoExchange14,
    name: 'BingX',
    value: 'exchange',
    link: 'https://bingx.com/',
  },
  {
    icon: images.ecoExchange15,
    name: 'Giottus',
    value: 'exchange',
    link: 'https://www.giottus.com/',
  },
  {
    icon: images.ecoExchange16,
    name: 'HTX',
    value: 'exchange',
    link: 'https://www.htx.com/',
  },
  {
    icon: images.ecoExchange17,
    name: 'Bitkub',
    value: 'exchange',
    link: 'https://www.bitkub.com/en/market/vic',
  },
  {
    icon: images.ecoInfra1,
    name: 'Pyth',
    value: 'infra',
    link: 'https://pyth.network/',
  },
  {
    icon: images.ecoInfra2,
    name: 'ThirdWeb',
    value: 'infra',
    link: 'https://thirdweb.com/',
  },
  {
    icon: images.ecoInfra3,
    name: 'dRPC',
    value: 'infra',
    link: 'https://drpc.org/',
  },
  {
    icon: images.ecoInfra4,
    name: 'D3',
    value: 'infra',
    link: 'https://d3.inc/',
  },
  {
    icon: images.ecoInfra5,
    name: 'FORWARDS',
    value: 'infra',
    link: 'https://forwardprotocol.io/',
  },
  {
    icon: images.ecoInfra6,
    name: 'Polygon CDK',
    value: 'infra',
    link: 'https://docs.polygon.technology/cdk/',
  },
  {
    icon: images.ecoInfra7,
    name: 'The Graph',
    value: 'infra',
    link: 'https://x.com/graphprotocol',
  },
  {
    icon: images.ecoInfra8,
    name: 'Chains Atlas',
    value: 'infra',
    link: 'https://docs.polygon.technology/cdk/',
  },
  {
    icon: images.ecoInfra9,
    name: 'GlitchD',
    value: 'infra',
    link: 'https://glitchd.network/',
  },
  {
    icon: images.ecoInfra10,
    name: 'Revoke',
    value: 'infra',
    link: 'https://revoke.cash/',
  },
  {
    icon: images.ecoInfra11,
    name: 'Humanode',
    value: 'infra',
    link: 'https://humanode.io/',
  },
  {
    icon: images.ecoInfra12,
    name: 'NOW Nodes',
    value: 'infra',
    link: 'https://nownodes.io/',
  },
  {
    icon: images.ecoInfra13,
    name: 'RockX',
    value: 'infra',
    link: 'https://www.rockx.com/',
  },
  {
    icon: images.ecoInfra14,
    name: 'SubQuery',
    value: 'infra',
    link: 'https://subquery.network/',
  },
  {
    icon: images.ecoInfra15,
    name: 'BlockPi',
    value: 'infra',
    link: 'https://blockpi.io/',
  },
  {
    icon: images.ecoInfra16,
    name: 'OneID',
    value: 'infra',
    link: 'https://www.oneid.xyz/',
  },
  {
    icon: images.ecoInfra17,
    name: 'Lumoz',
    value: 'infra',
    link: 'https://lumoz.org/',
  },
  {
    icon: images.ecoInfra18,
    name: 'Verichains',
    value: 'infra',
    link: 'https://verichains.io/',
  },
  {
    icon: images.ecoInfra19,
    name: 'Tally',
    value: 'infra',
    link: 'https://www.tally.xyz/',
  },
  {
    icon: images.ecoAppTool1,
    name: 'Galxe',
    value: 'app-tool',
    link: 'https://galxe.com/',
  },
  {
    icon: images.ecoAppTool2,
    name: 'Nansen',
    value: 'app-tool',
    link: 'https://www.nansen.ai/',
  },
  {
    icon: images.ecoAppTool3,
    name: 'Messari',
    value: 'app-tool',
    link: 'https://messari.io/',
  },
  {
    icon: images.ecoAppTool4,
    name: 'Token terminal',
    value: 'app-tool',
    link: 'https://tokenterminal.com/',
  },
  {
    icon: images.ecoAppTool5,
    name: 'Dune',
    value: 'app-tool',
    link: 'https://dune.com/',
  },
  {
    icon: images.ecoAppTool6,
    name: 'Blockscout',
    value: 'app-tool',
    link: 'https://www.blockscout.com/',
  },
  {
    icon: images.ecoAppTool7,
    name: 'NFTScan',
    value: 'app-tool',
    link: 'https://www.nftscan.com/',
  },
  {
    icon: images.ecoAppTool8,
    name: 'Zealy',
    value: 'app-tool',
    link: 'https://zealy.io/',
  },
  {
    icon: images.ecoAppTool9,
    name: 'QuestN',
    value: 'app-tool',
    link: 'https://questn.com/',
  },
  {
    icon: images.ecoAppTool10,
    name: 'Footprint Analytics',
    value: 'app-tool',
    link: 'https://footprint.network/',
  },
  {
    icon: images.ecoAppTool11,
    name: 'CocoCat',
    value: 'app-tool',
    link: 'https://www.cococat.io/',
  },
  {
    icon: images.ecoAppTool12,
    name: 'TaskOn',
    value: 'app-tool',
    link: '',
  },
  {
    icon: images.ecoAppTool13,
    name: 'CoinGecko',
    value: 'app-tool',
    link: 'https://www.coingecko.com/vi',
  },
  {
    icon: images.ecoAppTool14,
    name: 'CoinMarketCap',
    value: 'app-tool',
    link: 'https://coinmarketcap.com/',
  },
  {
    icon: images.ecoAppTool15,
    name: 'Soully',
    value: 'app-tool',
    link: 'https://x.com/SoullyProtocol',
  },
  {
    icon: images.ecoAppTool16,
    name: 'Escrow Dapp',
    value: 'app-tool',
    link: 'https://escrowdapp.com/',
  },
  {
    icon: images.ecoAppTool17,
    name: 'Herond',
    value: 'app-tool',
    link: 'https://herond.org/',
  },
  {
    icon: images.ecoAppTool18,
    name: 'Cede.store',
    value: 'app-tool',
    link: 'https://cede.store/',
  },
  {
    icon: images.ecoAppTool19,
    name: 'Comet',
    value: 'app-tool',
    link: 'https://cometbridge.app/',
  },
  {
    icon: images.ecoAppTool20,
    name: 'Revoke',
    value: 'app-tool',
    link: 'https://revoke.cash/',
  },
  {
    icon: images.ecoAppTool21,
    name: 'Magic Square',
    value: 'app-tool',
    link: 'https://magic.store/',
  },
  {
    icon: images.ecoAppTool22,
    name: 'Intract',
    value: 'app-tool',
    link: 'https://intract.io/',
  },
  {
    icon: images.ecoAppTool23,
    name: 'Chat3',
    value: 'app-tool',
    link: 'https://chat3.one/',
  },
  {
    icon: images.ecoAppTool24,
    name: 'ChainGPT',
    value: 'app-tool',
    link: 'https://www.chaingpt.org/',
  },
  {
    icon: images.ecoAppTool25,
    name: 'PoolZ',
    value: 'app-tool',
    link: 'https://www.poolz.finance/boost',
  },
  {
    icon: images.ecoAppTool26,
    name: 'Midle',
    value: 'app-tool',
    link: 'https://midle.io/',
  },
  {
    icon: images.ecoAppTool27,
    name: 'GeckoTerminal',
    value: 'app-tool',
    link: 'https://geckoterminal.com/',
  },
  {
    icon: images.ecoAppTool28,
    name: 'Chainlyze',
    value: 'app-tool',
    link: 'https://chainlyze.ai/',
  },
  {
    icon: images.ecoAppTool29,
    name: 'Quick Intel',
    value: 'app-tool',
    link: 'https://quickintel.io/',
  },
  {
    icon: images.ecoAppTool30,
    name: 'VICScan',
    value: 'app-tool',
    link: 'https://www.vicscan.xyz/',
  },
  {
    icon: images.ecoAppTool31,
    name: 'The Dapp List',
    value: 'app-tool',
    link: 'https://thedapplist.com/',
  },
  {
    icon: images.ecoOther1,
    name: 'Solide',
    value: 'other',
    link: 'https://dapp.solide0x.tech/viction',
  },
  {
    icon: images.ecoOther2,
    name: 'Domin',
    value: 'other',
    link: 'https://www.domin.foundation/',
  },
  {
    icon: images.ecoOther3,
    name: 'MudAI',
    value: 'other',
    link: 'https://x.com/MudAi_metaverse',
  },
]

const arrBuilds = [
  {
    icon: 'icon-up',
    title: 'Infra That Scales',
    info: 'Zero gas fees, login/payments, appchain stack.',
  },
  {
    icon: 'icon-launch',
    title: 'Launch Ready',
    info: 'Comms, docs, and community support on day one.',
  },
  {
    icon: 'icon-hype',
    title: 'Hype Engine',
    info: 'KOLs, quests, campaigns, and ambassadors.',
  },
  {
    icon: 'icon-funding',
    title: 'Real Funding',
    info: 'Grants for infra, audits, marketing, and liquidity.',
  },
  {
    icon: 'icon-massive',
    title: 'Massive Reach',
    info: '10M+ users from Ninety Eight Ecosystem & Viction community.',
  },
  {
    icon: 'icon-advisory',
    title: 'Advisory',
    info: 'Strategy for launch, branding, growth, and fundraising.',
  },
]

const arrDropdowns = [
  {
    name: 'All types',
    value: 'all',
  },
  {
    name: 'Defi',
    value: 'defi',
  },
  {
    name: 'Bridges',
    value: 'bridge',
  },
  {
    name: 'Payment',
    value: 'payment',
  },
  {
    name: 'Gamification',
    value: 'gamefi',
  },
  {
    name: 'NFTs',
    value: 'nft',
  },
  {
    name: 'Exchange',
    value: 'exchange',
  },
  {
    name: 'Infrastructure',
    value: 'infra',
  },
  {
    name: 'Application & tools',
    value: 'app-tool',
  },
  {
    name: 'Others',
    value: 'other',
  },
]

function EcosystemScreenNew() {
  const { positionY } = useResizeWidth()

  const partnerRefScreen1 = React.useRef(null)
  const partnerRefScreen2 = React.useRef(null)
  const partnerRefScreen3 = React.useRef(null)
  const partnerRefScreen4 = React.useRef(null)
  const partnerRefScreen5 = React.useRef(null)
  const ecosystemRef = React.useRef(null)
  const inputDropdownRef = React.useRef(null)

  const isScaleBanner = positionY >= 400
  const isActionSearchStand = positionY >= ecosystemRef.current?.offsetTop

  const arrPartners = [
    {
      icon: images.partnerLogo1,
      name: 'Constantine Zaitcev',
      sub: 'CEO | dRPC.org',
      detail:
        'Our Top tier web3 clients asked us to add Viction to our platform from day 1. And we glad that it has such high demand and consistent high performance.',
      position: partnerRefScreen2.current
        ? partnerRefScreen2.current.offsetTop
        : 0,
    },
    {
      icon: images.partnerLogo2,
      name: 'Raymond',
      sub: 'Co-founder | WSPN',
      detail:
        'Viction has fostered a highly active and vibrant community, an increasingly rare and valuable asset in the Web3 space. WSPN deeply appreciates Viction’s commitment to nurturing its ecosystem, and we believe our collaboration will further accelerate the advancement of future finance and payment innovation.',
      position: partnerRefScreen3.current
        ? partnerRefScreen3.current.offsetTop
        : 0,
    },
    {
      icon: images.partnerLogo3,
      name: 'Skirmantas Januškas',
      sub: 'CEO and Co-founder | DappRadar',
      detail:
        "Viction's infrastructure and support allowed our development team deploy Viction dapp tracking effortlessly, and ahead of schedule. In addition to the technology, the team at Viction are a genuine pleasure to work with.",
      position: partnerRefScreen4.current
        ? partnerRefScreen4.current.offsetTop
        : 0,
    },
    {
      icon: images.partnerLogo4,
      name: 'Chin',
      sub: 'Co-founder | RabbitSwap',
      detail:
        'Viction’s infrastructure has been the backbone of RabbitSwap since day one—enabling deeper liquidity, lower fees, and smoother on-chain experiences for our users. Proud to grow alongside such visionary partners.',
      position: partnerRefScreen5.current
        ? partnerRefScreen5.current.offsetTop
        : 0,
    },
  ]

  const [arrFilter, setArrFilter] = useState([
    {
      title: 'All',
      value: 'all',
    },
  ])
  const [arrData, setArrData] = useState([])
  const [filterChoose, setFilterChoose] = useState(arrFilter[0])
  const [isShowFilter, setIsShowFilter] = useState(false)
  const [isShowMore, setIsShowMore] = useState(false)
  const [isShowDropdown, setIsShowDropdown] = useState(false)
  const [dropdownChoose, setDropdownChoose] = useState(arrDropdowns[0])
  const [searchValue, setSearchValue] = useState('')

  const onFilter = useMemo(() => {
    if (filterChoose.value === 'all') {
      return arrProjectNew
    } else {
      return arrData.filter((item) => {
        return item.category.toLowerCase() === filterChoose.value
      })
    }
  }, [filterChoose])

  const projectSort = useMemo(() => {
    let dataTemp
    let dataFinal

    if (dropdownChoose.value === 'all') {
      dataTemp = arrProject
    } else {
      dataTemp = arrProject.filter((item) => {
        return item.value.toLowerCase() === dropdownChoose.value
      })
    }

    dataFinal = dataTemp.filter((item, i) => {
      return item.name.toLowerCase().includes(searchValue.toLowerCase())
    })

    return dataFinal
  }, [dropdownChoose, searchValue])

  const showMoreProject = isShowMore ? projectSort : projectSort.slice(0, 20)

  const handleFilter = (item) => () => {
    setFilterChoose(item)
  }

  const handleShowFilter = () => {
    setIsShowFilter(!isShowFilter)
  }

  useEffect(() => {
    let arrFilterTemp = arrProjectNew.map((item, i) => {
      return item.category
    })

    const uniqueSet = arrFilterTemp.reduce((unique, item) => {
      return unique.includes(item) ? unique : [...unique, item]
    }, [])

    const arrFilterConvert = uniqueSet.map((item) => {
      return {
        title: item,
        value: item.toLowerCase(),
      }
    })

    if (getLength(arrFilter) <= 1) {
      setArrFilter([...arrFilter, ...arrFilterConvert])
    }

    setArrData(arrProjectNew)
  }, [])

  useEffect(() => {
    if (inputDropdownRef.current) {
      if (isShowDropdown) {
        inputDropdownRef.current.focus()
      } else {
        inputDropdownRef.current.blur()
      }
    }
  }, [isShowDropdown])

  return (
    <div className={styles.ecosystemNewWrapper}>
      <div className='ecosystem-new'>
        <div className='ecosystem-banner'>
          <div className='banner-heading'>
            <h1>Viction Ecosystem</h1>

            <div className='heading-description'>
              Discover a worldwide landscape of dapps and integrations within
              the Viction ecosystem. Join our mission to empower human
              potential, fostering a truly open and secure world.
            </div>

            <div className='btn-action'>
              <a
                href='https://x.com/VictionEco'
                target='_blank'
                rel='noreferrer'>
                <Button>
                  Contact us{' '}
                  <span className='icon-web_arrow_up_right arrow-icon'></span>
                </Button>
              </a>
            </div>
          </div>

          <div className='eco-banner-img'>
            <img
              src={images.ecoNewBanner}
              alt='Ecosystem Banner'
              className='banner-img'
            />

            {/* <div
              className={`banner-img-box banner-img-box--left ${
                isScaleBanner && 'banner-img-box--left--scale'
              }`}>
              <img
                src={images.ecoBanner1}
                alt='Ecosystem Banner 1'
                className='banner-img banner-img--banner-1'
              />

              <img
                src={images.ecoBanner2}
                alt='Ecosystem Banner 2'
                className='banner-img banner-img--banner-2'
              />
            </div>
            <div
              className={`banner-img-box banner-img-box--right ${
                isScaleBanner && 'banner-img-box--right--scale'
              }`}>
              <img
                src={images.ecoBanner3}
                alt='Ecosystem Banner 3'
                className='banner-img banner-img--banner-3'
              />
            </div> */}
          </div>
        </div>

        <div className='ecosystem-partner'>
          <img
            src={images.curveBottomBlack}
            alt='Curve Bottom Black'
            className='curve-bottom-black'
          />

          <div className='ecosystem-partner-wrapper'>
            <div className='partner-container'>
              <h1 className='partner-title'>Partners' Insights</h1>

              <div className='partner-content-wrapper'>
                <div className='partner-content'>
                  <div className='partner-content-desk'>
                    {arrPartners.map((partner, index) => {
                      const itemHide =
                        positionY >= partner.position &&
                        index !== arrPartners.length - 1

                      return (
                        <div
                          className={`partner-item ${
                            itemHide && 'partner-item--hide'
                          }`}
                          key={index}>
                          <div className='partner-item-content'>
                            <div className='partner-item-content__logo'>
                              <img
                                src={partner.icon}
                                alt='Partner Logo 1'
                                className='logo-img'
                              />

                              <img
                                src={images.quote}
                                alt='Quote Icon'
                                className={`quote-icon ${
                                  itemHide && 'quote-icon--opacity'
                                }`}
                              />
                            </div>

                            <div className='partner-item-content__content'>
                              <div className='content-info'>
                                <div className='content-info--name'>
                                  {partner.name}
                                </div>

                                <div className='content-info--sub'>
                                  {partner.sub}
                                </div>
                              </div>

                              <div className='content-detail'>
                                {partner.detail}
                              </div>
                            </div>
                          </div>
                        </div>
                      )
                    })}
                  </div>

                  <div className='partner-content-tablet'>
                    <Swiper
                      loop={true}
                      modules={[Pagination, Autoplay]}
                      // autoplay={{
                      //   delay: 4000,
                      //   disableOnInteraction: false,
                      // }}
                      pagination={true}
                      className='partner-content-slider'>
                      {/* <SwiperSlide>1</SwiperSlide>
                      <SwiperSlide>2</SwiperSlide>
                      <SwiperSlide>3</SwiperSlide>
                      <SwiperSlide>4</SwiperSlide> */}
                      {arrPartners.map((partner, index) => {
                        const itemHide =
                          positionY >= partner.position &&
                          index !== arrPartners.length - 1

                        return (
                          <SwiperSlide key={index}>
                            <div
                              className={`partner-item ${
                                itemHide && 'partner-item--hide'
                              }`}>
                              <div className='partner-item-content'>
                                <div className='partner-item-content__logo'>
                                  <img
                                    src={partner.icon}
                                    alt='Partner Logo 1'
                                    className='logo-img'
                                  />

                                  <img
                                    src={images.quote}
                                    alt='Quote Icon'
                                    className={`quote-icon ${
                                      itemHide && 'quote-icon--opacity'
                                    }`}
                                  />
                                </div>

                                <div className='partner-item-content__content'>
                                  <div className='content-info'>
                                    <div className='content-info--name'>
                                      {partner.name}
                                    </div>

                                    <div className='content-info--sub'>
                                      {partner.sub}
                                    </div>
                                  </div>

                                  <div className='content-detail'>
                                    {partner.detail}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </SwiperSlide>
                        )
                      })}
                    </Swiper>
                  </div>
                </div>
              </div>
            </div>

            <div
              className='ecosystem-partner-screen'
              ref={partnerRefScreen1}></div>
            <div
              className='ecosystem-partner-screen'
              ref={partnerRefScreen2}></div>
            <div
              className='ecosystem-partner-screen'
              ref={partnerRefScreen3}></div>
            <div
              className='ecosystem-partner-screen'
              ref={partnerRefScreen4}></div>
            <div
              className='ecosystem-partner-screen'
              ref={partnerRefScreen5}></div>
          </div>
        </div>

        <div className='ecosystem-project' ref={ecosystemRef}>
          <div className='ecosystem-project-container'>
            <div className='ecosystem-project-content-wrapper'>
              <div className='ecosystem-project-content'>
                {showMoreProject.map((item, i) => {
                  return (
                    <a
                      href={item.link}
                      target='_blank'
                      rel='noopener noreferrer'
                      key={i}>
                      <div className='project-item'>
                        <div className='project-item__logo'>
                          <img
                            src={item.icon}
                            alt=''
                            className='logo-project'
                          />
                        </div>

                        <div className='project-item__info'>
                          <div className='info-name'>{item.name}</div>

                          <span className='icon-web_arrow_up_right project-icon-arrow'></span>
                        </div>
                      </div>
                    </a>
                  )
                })}
              </div>
            </div>

            {!isShowMore && projectSort.length > 20 && (
              <div className='show-more-action'>
                <div
                  className='text-hover-underline text-show-more'
                  onClick={() => setIsShowMore(true)}>
                  Show More
                </div>
              </div>
            )}

            <div
              className={`action-search ${
                isActionSearchStand && 'action-search--stand'
              }`}>
              <div className='input-box'>
                <input
                  type='text'
                  placeholder='Search your projects'
                  className='input-search'
                  value={searchValue}
                  onChange={(e) => setSearchValue(e.target.value)}
                />
              </div>

              <div className='dropdown-box'>
                <div
                  className='dropdown'
                  onClick={() => setIsShowDropdown(!isShowDropdown)}>
                  <div className='dropdown-label'>
                    {isShowDropdown ? (
                      <>
                        <input
                          type='text'
                          placeholder={dropdownChoose.name}
                          className='input-dropdown'
                          ref={inputDropdownRef}
                        />{' '}
                        <ChevronDownIcon size={16} />
                      </>
                    ) : (
                      <>
                        {dropdownChoose.name} <ChevronUpIcon size={16} />
                      </>
                    )}
                  </div>

                  <div
                    className={`dropdown-list ${
                      isShowDropdown && 'dropdown-list--show'
                    }`}>
                    <div className='dropdown-list-content'>
                      {arrDropdowns.map((item, index) => {
                        return (
                          <div
                            className='item-dropdown'
                            key={index}
                            onClick={() => setDropdownChoose(item)}>
                            {item.name}
                          </div>
                        )
                      })}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className='ecosystem-project-description'>
              <div className='description-content'>
                This information, provided by third-party projects, is for
                general information only. Viction does not guarantee its
                accuracy, nor should it imply endorsement or affiliation.
              </div>
            </div>
          </div>
        </div>

        <div className='ecosystem-build'>
          <div className='ecosystem-build-container'>
            <div className='build-heading'>
              <div className='build-heading-text'>
                <h2>Build on Viction</h2>
                <div className='heading-description'>
                  We bring the tools, network, and funding, so you can focus on
                  building.
                </div>
              </div>

              <div className='build-heading-btn'>
                <a
                  href='mailto:hi@viction.xyz'
                  target='_blank'
                  rel='noreferrer'>
                  <Button variant='secondary'>
                    Contact us{' '}
                    <span className='icon-web_arrow_up_right arrow-icon'></span>
                  </Button>
                </a>
              </div>
            </div>

            <div className='build-content'>
              {arrBuilds.map((item, index) => {
                return (
                  <div className='item-build-content' key={index}>
                    <span className={`icon-${item.icon} content-icon`}></span>

                    <div className='item-build-text'>
                      <div className='text-title'>{item.title}</div>

                      <div className='text-info'>{item.info}</div>
                    </div>
                  </div>
                )
              })}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default EcosystemScreenNew
